document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hp-sticky-atc]').forEach(function (bar) {
    var targetId = bar.getAttribute('data-observe-target');
    var target = targetId && document.getElementById(targetId);

    if (!target || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  });
});
